// extracted by mini-css-extract-plugin
export var button = "_dv-7";
export var buttonRow = "_dv-6";
export var fadeIn = "_dv-1";
export var gradient = "_dv-0";
export var panel = "_dv-2";
export var panelIn = "_dv-3";
export var subtitle = "_dv-5";
export var title = "_dv-4";